//import 'bootstrap/dist/css/bootstrap.css'
import 'react-bootstrap-typeahead/css/Typeahead.min.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
import './assets/app.css'
import './assets/bracket.min.css'
import './assets/font-awesome/css/font-awesome.css'
import './assets/Ionicons/css/ionicons.css'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import Root from './containers/Root'
import configureStore from './store/configureStore'
// import registerServiceWorker from './registerServiceWorker'

const store = configureStore()

render(
  <Provider store={store}>
    <Root/>
  </Provider>,
  document.getElementById('root'),
)
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js